import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Login from "../pages/login/page";
import Dashboard from "../pages/dashboard/page";
import Rezervasyonlar from "../pages/rezervasyonlar/page";
import RezervasyonForm from "../pages/rezervasyonlar/yeni/page";
import Bugun from "../pages/bugun/page";
import Yaklasan from "../pages/yaklasan/page";
import AracAtama from "../pages/arac-atama/page";
import GelirRaporlari from "../pages/gelir-raporlari/page";
import IlceAnalizi from "../pages/ilce-analizi/page";
import FiyatHesaplama from "../pages/fiyat-hesaplama/page";
import SoforHesap from "../pages/sofor-hesap/page";
import Araclar from "../pages/araclar/page";
import Musteriler from "../pages/musteriler/page";
import MemnuniyetAnketi from "../pages/memnuniyet-anketi/page";
import Ayarlar from "../pages/ayarlar/page";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/rezervasyonlar",
    element: <Rezervasyonlar />,
  },
  {
    path: "/rezervasyonlar/yeni",
    element: <RezervasyonForm />,
  },
  {
    path: "/bugun",
    element: <Bugun />,
  },
  {
    path: "/yaklasan",
    element: <Yaklasan />,
  },
  {
    path: "/arac-atama",
    element: <AracAtama />,
  },
  {
    path: "/sofor-hesap",
    element: <SoforHesap />,
  },
  {
    path: "/gelir-raporlari",
    element: <GelirRaporlari />,
  },
  {
    path: "/ilce-analizi",
    element: <IlceAnalizi />,
  },
  {
    path: "/fiyat-hesaplama",
    element: <FiyatHesaplama />,
  },
  {
    path: "/araclar",
    element: <Araclar />,
  },
  {
    path: "/musteriler",
    element: <Musteriler />,
  },
  {
    path: "/memnuniyet-anketi",
    element: <MemnuniyetAnketi />,
  },
  {
    path: "/ayarlar",
    element: <Ayarlar />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;